import './Autres.scss';

import logo from '../../Navbar/Logo_skinny.png';

import {NavLink, useNavigate} from 'react-router-dom';

import Loader from '../../Loader/Loader';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CottageIcon from '@mui/icons-material/Cottage';



const Autres = ({datas, loader}) => {

const navigate = useNavigate();

  return loader ? (

    <Loader />
  )
  :
  (

    <div className='page'>
    <h1 className='page-title'>
    <NavLink
        to='/'
      > <img src={logo}  alt='logo skinny' className='logo_pages-banner'/>
     
    </NavLink>
     - Catégorie Autres - </h1>
     <div className="img_container">
      {datas.map((data) => {
        return(
          
        <NavLink
        to={`/autres/zoom/${data.id}`} 
        >

          <img src={data.url} alt='autres' className='data_item'/>
        </NavLink>
        
        )
      })}
       </div>

  <NavLink
  to='/'
  className='page-back'
   > <CottageIcon/> 
   
  </NavLink>

  <button
      onClick={() => navigate(-1)}
      className='page-back--btn'
      >  <ArrowBackIosNewIcon/> 
    </button>


    </div>
  )
}

export default Autres;